export default __webpack_public_path__ + "static/media/bottle.e055b4dc.svg";